import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ArrowLeft, FileSpreadsheet, ArrowRight } from 'lucide-react';

/**
 * Excel ile POS aktarımı KAPATILDI.
 *
 * Satışlar adisyon kapanışında, tahsilatlar gün kapanışında POS'tan doğrudan
 * geliyor. Excel yolu aynı satışı ikinci kez girmenin ve elle düzeltilmiş
 * dosyalarla kayıt açmanın yoluydu; açık kaldığında iki kaynak birbirini
 * tutmuyordu. Geçmiş Excel kayıtları silinmedi, raporlarda duruyor.
 *
 * Sayfa 404 olmasın diye duruyor: eski yer imlerinden gelen kullanıcı nereye
 * bakacağını buradan görüyor.
 */
export default function PosTransfer() {
  return (
    <div className="p-6 max-w-3xl mx-auto space-y-4">
      <Link to="/erp/pos-integration">
        <Button variant="ghost" size="sm" className="gap-2">
          <ArrowLeft className="h-4 w-4" /> POS Entegrasyonu
        </Button>
      </Link>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-lg">
            <FileSpreadsheet className="h-5 w-5 text-muted-foreground" />
            Excel ile POS aktarımı kapatıldı
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4 text-sm text-muted-foreground">
          <p>
            POS verisi artık doğrudan bağlantıyla geliyor:
          </p>
          <ul className="space-y-2 list-disc pl-5">
            <li>
              <span className="text-foreground font-medium">Satışlar</span> — adisyon
              kapandığı anda aktarılır, stok reçeteye göre düşülür.
            </li>
            <li>
              <span className="text-foreground font-medium">Tahsilatlar</span> — gün
              kapanışında tek pakette, nihai haliyle aktarılır. Gün içi ödeme
              düzeltmeleri ayrıca gönderilmez.
            </li>
            <li>
              <span className="text-foreground font-medium">Veresiye</span> — eşleşen
              cari hesaba borç olarak yazılır; eşleşme yoksa beklemeye alınır ve
              eşleştirme yapıldığında otomatik işlenir.
            </li>
          </ul>
          <p>
            Daha önce Excel ile aktarılmış kayıtlar silinmedi, raporlarda olduğu gibi
            duruyor.
          </p>
          <Link to="/erp/pos-integration">
            <Button className="gap-2">
              POS Entegrasyonu ekranına git <ArrowRight className="h-4 w-4" />
            </Button>
          </Link>
        </CardContent>
      </Card>
    </div>
  );
}
